import { render, staticRenderFns } from "./BulkAdjustPriceModal.vue?vue&type=template&id=356b5e03&scoped=true"
import script from "./BulkAdjustPriceModal.vue?vue&type=script&lang=js"
export * from "./BulkAdjustPriceModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAdjustPriceModal.vue?vue&type=style&index=0&id=356b5e03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b5e03",
  null
  
)

export default component.exports